/**
 * Parse time string like "10 minutes" to seconds
 */
export const parseExpiresIn = (expiresIn: string): number => {
  const lower = expiresIn.toLowerCase().trim();
  
  // Match patterns like "10 minutes", "5 mins", "1 hour", etc.
  const minuteMatch = lower.match(/(\d+)\s*(?:minute|min|m)/);
  if (minuteMatch) {
    return parseInt(minuteMatch[1], 10) * 60;
  }
  
  const hourMatch = lower.match(/(\d+)\s*(?:hour|hr|h)/);
  if (hourMatch) {
    return parseInt(hourMatch[1], 10) * 60 * 60;
  }
  
  const secondMatch = lower.match(/(\d+)\s*(?:second|sec|s)/);
  if (secondMatch) {
    return parseInt(secondMatch[1], 10);
  }
  
  // Default to 60 seconds if can't parse
  return 60;
};

